// Chakra imports
import {
	Box,
	Button,
	Flex,
	FormControl,
	FormLabel,
	HStack,
	Icon,
	Input,
	Link,
	Switch,
	Text,
	useColorModeValue,
	Heading,
	Checkbox,
} from "@chakra-ui/react";
// Assets
import React from "react";
import { Link as ReachLink } from "react-router-dom";
import { GoogleIcon } from "components/Icons/Icons";
import { FacebookIcon } from "components/Icons/Icons";

function SignUp() {
	const titleColor = useColorModeValue("teal.300", "teal.200");
	const textColor = useColorModeValue("gray.700", "white");
	return (
		<Flex
			align="center"
			justify="center"
			h={{ sm: "initial", md: "100vh", lg: "100vh" }}
			pt={{ sm: "100px", md: "10px" }}
			mt={8}
		>
			<Box
				bg="#33333B"
				borderRadius="16px"
				py="32px"
				px="15px"
				pt={0}
				style={{ userSelect: "none" }}
				w={{ base: "100%", md: "500px", lg: "500px" }}
			>
				<Flex
					direction="column"
					align="center"
					gap={5}
					w="100%"
					p="48px"
					pt={10}
					// mt={{ md: "150px", lg: "80px" }}
				>
					<Heading color="#ffff" fontSize="32px">
						Sign Up
					</Heading>
					<Button w="100%">
						<GoogleIcon mr={2} /> Login with Google
					</Button>
					<Button w="100%">
						<FacebookIcon mr={2} />
						Login with Facebook
					</Button>
					<Text color={textColor} fontWeight="bold" fontSize="14px">
						OR
					</Text>
					<FormControl>
						<FormLabel fontSize="sm" fontWeight="normal">
							Email
						</FormLabel>
						<Input
							borderRadius="15px"
							fontSize="sm"
							mb={5}
							type="text"
							placeholder="Your email adress"
							size="lg"
						/>
						<FormLabel fontSize="sm" fontWeight="normal">
							Password
						</FormLabel>
						<Input
							borderRadius="15px"
							mb="36px"
							fontSize="sm"
							type="password"
							placeholder="Your password"
							size="lg"
						/>
						<FormControl display="flex" mb={5} alignItems="center">
							<Flex direction="row">
								<Checkbox id="remember-login" colorScheme="#16BF5D" me="10px" />
								<FormLabel
									htmlFor="remember-login"
									mb="0"
									ms="1"
									fontWeight="normal"
									color="#83888D"
								>
									Remember me
								</FormLabel>
							</Flex>
							<Text ms="auto" display="none">
								forgot password?
							</Text>
						</FormControl>
						<Button
							fontSize="10px"
							type="submit"
							bg="#16BF5D"
							w="100%"
							h="45"
							color="white"
							_hover={{
								bg: "#16BF5D",
							}}
							_active={{
								bg: "teal.400",
							}}
						>
							Create Account
						</Button>
					</FormControl>
					<Flex
						flexDirection="column"
						justifyContent="center"
						gap={5}
						alignItems="center"
						maxW="100%"
					>
						<Text color="#83888D">
							By creating an account, you agree to our{" "}
							<Box as="span" color="#16BF5D">
								Terms of Use
							</Box>{" "}
							and{" "}
							<Box as="span" color="#16BF5D">
								Privacy Policy
							</Box>
						</Text>
						<Text color="#83888D" fontWeight="medium">
							Already have an account?
							<Link
								color="#16BF5D"
								as={ReachLink}
								ms="5px"
								fontWeight="bold"
								to="signin"
							>
								Login
							</Link>
						</Text>
					</Flex>
				</Flex>
			</Box>
		</Flex>
	);
}

export default SignUp;
